import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ spacing, palette, mixins }) => ({
  dialogRoot: {
    maxHeight: "max-content",
    left: "unset",
    bottom: "unset"
  },
  dialogContainer: {
    justifyContent: "flex-end",
    alignItems: "flex-start",
    position: "relative"
  },
  title: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: palette.primary[50],
    borderRadius: "6px",
    padding: spacing(2),
    marginBottom: spacing(2),
    cursor: "grab"
  },
  scrollArea: {
    // a11y: contain visually hidden (absolute) text, or VoiceOver scrolls the whole panel to reach it.
    position: "relative",
    overflowY: "auto",
    minHeight: 0,
    paddingRight: spacing(2),
    scrollbarWidth: "auto",
    scrollbarColor: "auto",

    // Styled scrollbars stay visible in Chrome and Safari instead of hiding until the user scrolls.
    "&::-webkit-scrollbar": {
      width: "8px"
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: palette.primary[50],
      borderRadius: "4px"
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: palette.primary[500],
      borderRadius: "4px"
    },

    "&:focus-visible": {
      ...mixins.focusRing.ring
    }
  },
  moveButton: {
    cursor: "grab",
    // a11y: keyboard-only move control; mouse users drag the title bar, so it shows only while focused.
    "&:not(:focus)": {
      position: "absolute",
      width: 1,
      height: 1,
      margin: -1,
      padding: 0,
      border: 0,
      overflow: "hidden",
      clip: "rect(0 0 0 0)",
      whiteSpace: "nowrap"
    }
  }
}))
